import React from 'react'
import dompurify from 'dompurify'

const AccordionChildContent = ({ text = '' }) => {
  const sanitizer = dompurify.sanitize
  return (
    <li>
      <p dangerouslySetInnerHTML={{ __html: sanitizer(text) }} />
    </li>
  )
}

export default AccordionChildContent
